import { render, staticRenderFns } from "./Coaching_PERMA.vue?vue&type=template&id=13e95186"
import script from "./Coaching_PERMA.vue?vue&type=script&lang=js"
export * from "./Coaching_PERMA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports